import { render, staticRenderFns } from "./TxPresenterPresentMode.vue?vue&type=template&id=7b5d70b1&scoped=true"
import script from "./TxPresenterPresentMode.vue?vue&type=script&lang=js"
export * from "./TxPresenterPresentMode.vue?vue&type=script&lang=js"
import style0 from "./TxPresenterPresentMode.vue?vue&type=style&index=0&id=7b5d70b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d70b1",
  null
  
)

export default component.exports